export default __webpack_public_path__ + "static/media/international_outbound.fde014ee.svg";